import React from 'react';

const MovimentoPrevDef =  ({ tipo }) => {

    return tipo === 'D' ?
        (<i className="checkmark green icon" title="Definitivo"/>)
        :
        (<i className="wait gray icon" title="Previsionale"/>)
};

export default MovimentoPrevDef;


/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentoPrevDef.js
 **/